import { inject, injectable } from '@wix/typesafe-inversify';
import { Services } from '../../ioc/services';
import type { IMonitoring } from './IMonitoring';
import type { ITransaction } from './ITransaction';

@injectable()
export class Monitoring implements IMonitoring {
  constructor(
    @inject(Services.TransactionFactory)
    private readonly transactionFactory: (name: string) => ITransaction,
  ) {}

  /**
   * Creates a transaction tracker with the specified name
   * @param name The name of the transaction to track
   * @returns Transaction object to control the transaction lifecycle
   */
  transaction(name: string): ITransaction {
    return this.transactionFactory(name);
  }
}
